/** Sidebar and command-palette navigation for Hivemind Subterfuge Platform */

export const PLATFORM_NAME = 'HIVEMIND';
export const PLATFORM_TAGLINE = 'SUBTERFUGE PLATFORM';

export const NAV_SECTIONS = [
  {
    id: 'intelligence',
    title: 'Intelligence',
    items: [
      { to: '/intelligence/search', label: 'Search', icon: '🔍' },
      { to: '/intelligence/history', label: 'History', icon: '🕘' },
      { to: '/intelligence/extractor', label: 'Extractor', icon: '🧩' },
      { to: '/intelligence/compare', label: 'Compare', icon: '⚖️' },
      { to: '/intelligence/panel-hunter', label: 'Panel Hunter', icon: '🎯' },
      { to: '/intelligence/corpus', label: 'Corpus', icon: '📚' },
    ],
  },
  {
    id: 'dfr',
    title: 'DFR',
    items: [
      { to: '/dfr', label: 'Overview', icon: '📉', end: true },
      { to: '/dfr/clients', label: 'Clients', icon: '👥' },
      { to: '/dfr/cases', label: 'Exposure Cases', icon: '📋' },
      { to: '/dfr/queue', label: 'Broker Queue', icon: '📥' },
      { to: '/dfr/monitoring', label: 'Monitoring', icon: '🔭' },
      { to: '/dfr/evidence', label: 'DFR Evidence', icon: '📎' },
      { to: '/dfr/reports', label: 'DFR Reports', icon: '📊' },
      { to: '/dfr/settings', label: 'DFR Settings', icon: '🛠️' },
    ],
  },
  {
    id: 'investigations',
    title: 'Investigations',
    items: [
      { to: '/', label: 'Dashboard', icon: '📊', end: true },
      { to: '/cases', label: 'Cases', icon: '🗂️' },
      { to: '/observables', label: 'Observables', icon: '👁️' },
      { to: '/indicators', label: 'Indicators', icon: '🎯' },
      { to: '/actors', label: 'Threat Actors', icon: '🕵️' },
      { to: '/organizations', label: 'Organizations', icon: '🏢' },
      { to: '/countries', label: 'Countries', icon: '🌍' },
      { to: '/evidence', label: 'Evidence', icon: '🔒' },
      { to: '/reports', label: 'Reports', icon: '📄' },
      { to: '/audit', label: 'Audit Log', icon: '📝' },
    ],
  },
  {
    id: 'engagement',
    title: 'Engagement',
    items: [
      { to: '/personas', label: 'Personas', icon: '🎭' },
      { to: '/agents', label: 'Decoy Assets', icon: '🖥️', badgeKey: 'agentsOnline' },
      { to: '/listeners', label: 'Intake Endpoints', icon: '📡' },
      { to: '/tasks', label: 'Workflows', icon: '📋' },
      { to: '/console', label: 'Analyst Console', icon: '💻' },
      { to: '/payloads', label: 'Artifact Deploy', icon: '📦' },
    ],
  },
  {
    id: 'system',
    title: 'System',
    items: [
      { to: '/docs', label: 'Documentation', icon: '📚' },
      { to: '/settings', label: 'Settings', icon: '⚙️' },
    ],
  },
];

export const COMMAND_ROUTES = NAV_SECTIONS.flatMap((section) =>
  section.items.map((item) => ({
    id: item.to,
    label: item.label,
    section: section.title,
    to: item.to,
  }))
);

export const ENTITY_BADGES = {
  case: { label: 'CASE', className: 'entity-badge-case' },
  indicator: { label: 'INDICATOR', className: 'entity-badge-indicator' },
  observable: { label: 'OBSERVABLE', className: 'entity-badge-observable' },
  search: { label: 'SEARCH', className: 'entity-badge-search' },
  actor: { label: 'ACTOR', className: 'entity-badge-actor' },
  organization: { label: 'ORG', className: 'entity-badge-organization' },
  persona: { label: 'PERSONA', className: 'entity-badge-persona' },
};
